const DepthTitle = (depthNo, disabled, title) => {
  const button = document.createElement('button');
  button.classList.add('tit');
  button.setAttribute('type', 'button');
  button.setAttribute('data-index', depthNo);
  if (disabled) button.setAttribute('disabled', 'disabled');
  button.textContent = title;
  return button;
};

export default DepthTitle;

function toggleDepth(depthNo, allDepthContainer, isOpen) {
  if (!allDepthContainer) return;

  function getDeptList() {
    if (allDepthContainer.classList.contains('calendar_wrap')) {
      return allDepthContainer.parentElement.parentElement;
    }
    return [ ...allDepthContainer.querySelectorAll('.dep-sel') ];
  }

  getDeptList().forEach((depth, index) => {
    // 선택한 depth가 아니면 open 클래그 제거
    if (depthNo !== index) {
      depth.classList.remove('open');
      return;
    }

    // depth 옵션 선택은 다음 depth에 무조건 open 클래스 추가
    if (isOpen) {
      depth.classList.add('open');
      return;
    }

    // 선택한 depth는 토글
    depth.classList.toggle('open');
  });
}

export {
  toggleDepth,
};
